import { AssistantAvatar } from "./AssistantAvatar";
import { UserAvatar } from ".//UserAvatar";
import VolumeLevel from "./VolumeLevel";
import AssistantSpeechIndicator from "./AssistantSpeechIndicator";

type ActiveCallDetailProps = {
  assistantIsSpeaking: boolean;
  volumeLevel: number;
};

const ActiveCallDetail = ({ assistantIsSpeaking, volumeLevel }: ActiveCallDetailProps) => {
  return (
    <div className="flex flex-col items-center justify-evenly p-4 border border-border rounded-lg shadow-sm w-full bg-background">
      {/* <UserAvatar isSpeaking={!assistantIsSpeaking} name="user" avatar="/window.svg" />
      <AssistantAvatar
        isSpeaking={assistantIsSpeaking}
        name="assistant"
        avatar="/next.svg"
        volumeLevel={volumeLevel}
      /> */}
      <VolumeLevel volume={volumeLevel} assistantIsSpeaking={assistantIsSpeaking} />
      <AssistantSpeechIndicator isSpeaking={assistantIsSpeaking} />
    </div>
  );
};

export default ActiveCallDetail;
